import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["type", "icon", "statusIcon", "iconProps", "children", "className", "grouped", "classes"];
import * as React from 'react';
import clsx from 'clsx';
import Svg from '../../../components/Svg';
import { StatusIcon } from '../../../components/Private';
import { CellContext } from '../context';
var styles = {
  "root": "ListCell-root_1HxzV",
  "grouped": "ListCell-grouped_1YKqx",
  "primary": "ListCell-primary_1AlGh",
  "secondary": "ListCell-secondary_Gp2Ih Widget-hoverChild_1azKL",
  "with-icon": "ListCell-with-icon_2Enbd",
  "icon": "ListCell-icon_VwfQD",
  "statusIcon": "ListCell-statusIcon_3Hcxs",
  "icon-prefix": "ListCell-icon-prefix_17Fv5",
  "icon-suffix": "ListCell-icon-suffix_3fQvp"
};
var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-disabled": "SVG-fill-disabled_2Wv9a SVG-fill-grey_BVkZ6"
};
function ListCell(_ref) {
  var _clsx3;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    icon = _ref.icon,
    statusIcon = _ref.statusIcon,
    iconProps = _ref.iconProps,
    children = _ref.children,
    className = _ref.className,
    grouped = _ref.grouped,
    classes = _ref.classes,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var context = React.useContext(CellContext);

  /**
   * Helper: allow to pass classes to component childs.
   */
  var classOf = function classOf(key) {
    var _classes$key;
    return (_classes$key = classes === null || classes === void 0 ? void 0 : classes[key]) !== null && _classes$key !== void 0 ? _classes$key : '';
  };
  var isGrouped = typeof grouped === 'boolean' ? grouped : context.grouped;
  var hasIcon = icon && Svg.has(icon.name);
  var hasStatusIcon = typeof (statusIcon === null || statusIcon === void 0 ? void 0 : statusIcon.position) === 'string' &&
  // $FlowFixMe[unnecessary-optional-chain]
  typeof (statusIcon === null || statusIcon === void 0 ? void 0 : statusIcon.theme) === 'string';
  var renderIcon = function renderIcon() {
    var _clsx;
    if (!icon || !hasIcon) return null;
    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]
      React.createElement(Svg, _extends({
        name: icon.name,
        className: clsx(styles.icon, (_clsx = {}, _defineProperty(_clsx, styles['icon-prefix'], icon.position === 'prefix'), _defineProperty(_clsx, styles['icon-suffix'], icon.position === 'suffix'), _defineProperty(_clsx, svgStyles["fill-".concat(icon.fill)], icon.fill), _clsx), classOf('icon'))
      }, iconProps))
    );
  };
  var renderStatusIcon = function renderStatusIcon() {
    var _clsx2;
    if (!statusIcon || !hasStatusIcon) return null;
    return /*#__PURE__*/React.createElement(StatusIcon, {
      intent: statusIcon.theme,
      className: clsx(styles.statusIcon, (_clsx2 = {}, _defineProperty(_clsx2, styles['icon-prefix'], statusIcon.position === 'prefix'), _defineProperty(_clsx2, styles['icon-suffix'], statusIcon.position === 'suffix'), _clsx2), classOf('icon'))
    });
  };
  var rootClasses = clsx(styles.root, (_clsx3 = {}, _defineProperty(_clsx3, styles.primary, type === 'primary'), _defineProperty(_clsx3, styles.secondary, type === 'secondary'), _defineProperty(_clsx3, styles.grouped, isGrouped), _defineProperty(_clsx3, styles['with-icon'], hasIcon || hasStatusIcon), _clsx3), classOf('root'), className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("span", _extends({
      className: rootClasses
    }, extraProps), hasIcon && renderIcon(), hasStatusIcon && renderStatusIcon(), children)
  );
}
export default ListCell;